<template>
  <div v-if="parution">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailParution.title', {nom: parution.nomParution })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button
              @click="checkPermissions(permsParution.maj) ? $router.push({
                name: 'm.presse.parution-edit',
                params: { id: parution.id }
              }) : showPopUpPermission()"
              :class="{'button-access-no-permission':
                !checkPermissions(permsParution.maj)}"
              class="button is-addOrEdit">
              {{ $t('detailParution.actions.edit') }}
            </button>
            <b-dropdown class="button is-bottom-left has-text-left is-relative">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7">
                  {{$t('catalogue.newProduct.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item
                v-for="(accesRapide, index) in genererAllAccesRapide"
                :key="index"
                class="is-paddingless">
                <router-link-blank
                  :to="{ name: accesRapide.name, params: accesRapide.params}"
                  class="pdt-5px pdb-5px"
                  classMessage="has-text-default is-size-6 is-block mgl-20px mgr-20px"
                  classComposant="noTextDecoration"
                  :message="accesRapide.libelle">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permsParution.editer)
                      ? popUpEdition = true
                      : showPopUpPermission()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <informations :parution="parution" :produit="produit" />
    <pages-parution :parution="parution" is-detail/>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition="listeChoiceEdition"
        @editionChoose="editionParution">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import edition from '@/api/edition';
import { get } from '@/api/presse/parution';
import { get as getPresse } from '@/api/produit/produitPresse';
import AppBreadcrumb from '@/components/general/breadcrumb';
import Informations from '@/components/presse/parution/detail/informations';
import PagesParution from '@/components/presse/parution/pagesParution';
import popUpEdition from '@/components/factures/p_edition';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import { PARUTION } from '@/configuration/presse/permissionsPresseConf';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import {
  LISTE_CHOICE_EDITION_PARUTION,
  TYPE_EDITION_REALISE,
  TYPE_EDITION_RELEVE_DE_PUB,
  TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE,
  TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE,
  TYPE_EDITION_PARUTION_REPORTING,
} from '@/configuration/presse/parution/parutionConfig';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    AppBreadcrumb,
    Informations,
    PagesParution,
    routerLinkBlank,
    popUpEdition,
  },
  data() {
    return {
      parution: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      permsParution: PARUTION,
      produit: null,
      popUpEdition: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_PARUTION.filter(
        option => option.typeDonnee !== TYPE_EDITION_PARUTION_REPORTING,
      ),
      constantes: {
        pdf: TYPE_PDF,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailParution.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailParution.breadcrumb.liste'), route: { name: 'l.presse.parution' }, isActive: false },
        { title: this.$i18n.t('detailParution.breadcrumb.detail'), route: { name: '' }, isActive: true },
      ];
    },
    genererAllAccesRapide() {
      return [
        { name: 'l.bodac.factures-par-parution', params: { parutionId: this.$route.params.id }, libelle: this.$t('detailParution.accesRapide.factures') },
        { name: 'l.bodac.commandes-liste-par-parution', params: { parutionId: this.$route.params.id }, libelle: this.$t('detailParution.accesRapide.commandes') },
        { name: 'l.bodac.commandes-echeances-par-parution', params: { parutionId: this.$route.params.id }, libelle: this.$t('detailParution.accesRapide.commandesAFacturer') },
        { name: 'l.presse.plan_media-par-parution', params: { parutionId: this.$route.params.id }, libelle: this.$t('detailParution.accesRapide.planMedia') },
        { name: 'm.presse.parution-bat', params: { parutionId: this.$route.params.id }, libelle: this.$t('detailParution.accesRapide.bat') },
      ];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    async editionParution(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const editionInput = {
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            societeId: this.societeActiveId,
          },
        };
        switch (donnees.typeDonnee) {
          case TYPE_EDITION_REALISE:
          case TYPE_EDITION_RELEVE_DE_PUB:
          case TYPE_EDITION_RELEVE_DE_PUB_RAPPROCHE:
            editionInput.ids = [this.parution.produitId];
            editionInput.parametresAdditionnels.parutionsIds = this.parution.id;
            break;
          case TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE:
            editionInput.ids = [this.parution.id];
            editionInput.parametresAdditionnels.sansPageVide = 'True';
            break;
          default:
            editionInput.ids = [this.parution.id];
            break;
        }
        const response = await edition(editionInput);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.parution = (await get(this.$route.params.id)).data.result;
      this.produit = (await getPresse(this.parution.produitId)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.parution.nomParution }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
